import React from 'react';
import LazyImage from 'src/utils/lazyImage';

const Feature = ({ iconPath, name, description }) => (
  <div className="home__feature">
    <div className="home__feature__content">
      <div className="home__feature__content__imagecontainer">
        <LazyImage
          alt={name}
          classnames="home__feature__content__image"
          src={iconPath}
        />
      </div>
      <div className="home__feature__content__name">{name}</div>
      <div className="home__feature__content__description">{description}</div>
    </div>
  </div>
);

export default Feature;
